// Google Analytics utility functions

declare global {
  interface Window {
    gtag: (...args: any[]) => void;
    dataLayer: any[];
  }
}

// Initialize Google Analytics
export const GA_TRACKING_ID = process.env.REACT_APP_GTM_ID ?? '';

// Check if GTM is properly loaded
export const isGTMLoaded = () => {
  const hasDataLayer = typeof window !== 'undefined' && window.dataLayer;
  const hasGTMId = !!GA_TRACKING_ID;
  
  console.log('GTM Status:', {
    hasDataLayer,
    hasGTMId,
    dataLayerLength: hasDataLayer ? window.dataLayer.length : 0,
    gtmId: GA_TRACKING_ID
  });
  
  return hasDataLayer && hasGTMId;
};

// Log the pageview with their URL
export const pageview = (url: string) => {
  if (typeof window !== 'undefined' && window.dataLayer && GA_TRACKING_ID) {
    const pageViewData = {
      event: 'page_view',
      page_path: url,
      page_title: document.title,
      page_location: window.location.href
    };
    
    console.log('GTM: Pushing page_view event:', pageViewData);
    window.dataLayer.push(pageViewData);
  } else {
    console.log('GTM: Cannot track page view - missing dataLayer or GTM_ID');
  }
};

// Log specific events happening
export const event = (action: string, category: string, label?: string, value?: number) => {
  if (typeof window !== 'undefined' && window.dataLayer && GA_TRACKING_ID) {
    const eventData = {
      event: 'custom_event',
      event_action: action,
      event_category: category,
      event_label: label,
      value: value,
    };
    
    console.log('GTM: Pushing custom event:', eventData);
    window.dataLayer.push(eventData);
  } else {
    console.log('GTM: Cannot track event - missing dataLayer or GTM_ID');
  }
};

// Track custom events
export const trackEvent = (eventName: string, parameters?: Record<string, any>) => {
  if (typeof window !== 'undefined' && window.dataLayer && GA_TRACKING_ID) {
    const eventData = {
      event: eventName,
      ...parameters
    };
    
    console.log('GTM: Pushing track event:', eventData);
    window.dataLayer.push(eventData);
  } else {
    console.log('GTM: Cannot track custom event - missing dataLayer or GTM_ID');
  }
};
